import * as constants from "@/constants";
import md5 from "md5-js";

export function getTempKey() {
    const tempKey = new Date().getTime();
    const salt = "qiluomite_XYZ_654321^&";
    const str = tempKey + salt;
    const tempSecret = md5(md5(str) + salt);
    return { tempKey, tempSecret };
}

// 无感验证
export function invisible(action = "getInfo") {
    let googleVerifyTimer = null;
    let manualVerification = false; // 手动验证
    return new Promise((resolve) => {
        try {
            clearTimeout(googleVerifyTimer);
            // 超时时间
            googleVerifyTimer = setTimeout(() => {
                resolve({ state: "error", manualVerification });
            }, 10000);
            waitForTurnstileLoad()
                .then(() => {
                    // eslint-disable-next-line no-undef
                    turnstile.render("#cloudflare_invisible", {
                        sitekey: constants.CLOUDFLARE_SITEKEY_INVISIBLE,
                        action: action,
                        retry: "never",
                        language: "en",
                        theme: "light",

                        callback: function (token) {
                            resolve({ state: "success", token });
                        },
                        "error-callback": function (e) {
                            if (e.indexOf("600") || e.indexOf("300")) {
                                manualVerification = true;
                            }
                            resolve({ state: "error", manualVerification });
                        },
                    });
                })
                .catch((e) => {
                    console.error("waitForTurnstileLoad error:", e);
                    manualVerification = true;
                    resolve({ state: "error", manualVerification });
                });
        } catch (e) {
            if (e.indexOf("600") || e.indexOf("300")) {
                manualVerification = true;
            }
            resolve({ state: "error", manualVerification });
        }
    }).finally(() => {
        clearTimeout(googleVerifyTimer);
    });
}

// 通过cdyoutube域名跳转时，有可能出现人机验证sdk还没加载完成。需要监听加载完成后再执行相关操作。
function waitForTurnstileLoad() {
    return new Promise((resolve, reject) => {
        const script = document.getElementById("turnstile-sdk");

        if (!script) {
            reject(new Error("Turnstile script tag not found"));
            return;
        }

        if (window.turnstile) {
            resolve(window.turnstile); // 已经加载完成
            return;
        }

        script.addEventListener("load", () => {
            resolve(window.turnstile);
        });

        script.addEventListener("error", () => {
            reject(new Error("Failed to load Turnstile SDK"));
        });
    });
}
